module.exports = __webpack_public_path__ + "img/immobilien.5b8b519d.png";